<ng-container *ngIf="!noMovieDetailTag; else noMovieDetailTemplate">
  <div id="movie-detail" [ngClass]="movieTagClass">
    <ush-feature-movie-hero [movie]="movie" [hideWatchNowCtaButton]="!showWatchNowCtaButton" />

    <ng-template #filmInteractionComponent></ng-template>

    <ush-feature-laurels-carousel
      *ngIf="movieLaurels?.length > 0"
      [laurels]="movieLaurels"
    ></ush-feature-laurels-carousel>

    <ng-container *ngIf="movie">
      <div *ngIf="!detailContentAlternative" class="movie-detail-content page-content">
        <ush-movie-title id="titleOutside" class="title-outside" [movie]="movie"></ush-movie-title>

        <div class="info info-left" *ngIf="!loading; else infoLoader">
          <ush-movie-title id="titleInside" [movie]="movie" class="title-inside"></ush-movie-title>

          <ush-movie-synopsis id="synopsis" [movie]="movie"></ush-movie-synopsis>

          <ush-movie-reasons-to-watch
            id="reasonsToWatch"
            *ngIf="movie.trReasonsToWatch"
            [movie]="movie"
          ></ush-movie-reasons-to-watch>

          <div #movieDetailPoint id="movieDetailPoint" class="see-more-scroll-point"></div>
          <div *ngIf="movie.movieCrew" class="movie-credits-block">
            <ush-movie-credits id="movieCredits" [movie]="movie"></ush-movie-credits>
          </div>
          <div *ngIf="thereIsMoreInfo(movie)" class="movie-more-information-block">
            <ush-movie-more-information
              id="movieMoreInformation"
              [movie]="movie"
              class="main"
            ></ush-movie-more-information>
          </div>
          <!-- ALTERNATIVE BLOCK -->
          <div class="movie-deta-alternative-block">
            <div *ngIf="movie.movieCrew">
              <ush-movie-credits id="movieCredits" [movie]="movie"></ush-movie-credits>
            </div>
            <div *ngIf="thereIsMoreInfo(movie)">
              <ush-movie-more-information id="movieMoreInformation" [movie]="movie" class="main" />
            </div>
          </div>
          <!-- END ALTERNATIVE BLOCK -->
        </div>

        <ng-template #infoLoader>
          <ush-skeleton-loader
            class="info info-left"
            [sections]="[
              { title: true, rows: 2 },
              { title: true, rows: 3 }
            ]"
          ></ush-skeleton-loader>
        </ng-template>
        <div id="infoRight" class="info info-right">
          <div id="showtimeStreamingWidget">
            <ush-showtime-streaming
              [movie]="movie"
              [priorityType]="!!showtimeStreamingPriority"
              [hideTabs]="hideShowtimeStreamingTabs"
            ></ush-showtime-streaming>
            <ng-container *ngIf="!shareInThumbnail">
              <ush-movie-tell-friends [movie]="movie"></ush-movie-tell-friends>
            </ng-container>
          </div>

          <!-- ASSETS LOCKER -->
          @if (movie?.hasAssets) {
            <ush-assets-locker-link [movie]="movie" />
          }
        </div>

        <!-- move here the sign up module -->
      </div>

      <ng-container *ngIf="detailContentAlternative">
        <ng-container
          [ngTemplateOutlet]="detailContent2"
          [ngTemplateOutletContext]="{ $implicit: movie }"
        ></ng-container>
      </ng-container>

      <div *ngIf="thereIsMoreInfo(movie)">
        <ush-movie-more-information
          id="movieMoreInformation"
          [movie]="movie"
          class="secondary page-content"
        ></ush-movie-more-information>
      </div>

      <!-- Reviews carousel -->
      <div *ngIf="!disableReviews && movie.reviews">
        <div id="reviewsCarousel" class="reviews-carousel page-content">
          <swiper-container ushSwiperElement [config]="reviewsSwiperConfig" init="false">
            <swiper-slide *ngFor="let reviewItem of movie.reviews">
              <div class="review-item">
                <div class="review-item-quote">{{ '"' + reviewItem.quote + '"' }}</div>
                <ush-movie-rating [rating]="reviewItem.rating" [size]="3"></ush-movie-rating>
                <div class="review-item-source">{{ reviewItem.press.name }}</div>
              </div>
            </swiper-slide>
          </swiper-container>
        </div>
      </div>

      <!-- Gallery -->
      <div class="slider-external-wrapper videos" *ngIf="!disableVideos && movie.movieVideos">
        <div id="videosGallery" class="page-content slider-container">
          <ush-feature-videos-carousel [videos]="movie.movieVideos"></ush-feature-videos-carousel>
        </div>
      </div>
      <div class="slider-external-wrapper gallery" *ngIf="!disableGallery && movie.movieImages">
        <div id="galler" class="page-content slider-container">
          <feature-gallery-carousel
            *ngIf="movie.movieImages"
            [images]="movie.movieImages"
            [imageOrientation]="'landscape'"
          ></feature-gallery-carousel>
        </div>
      </div>
      <div class="slider-external-wrapper posters" *ngIf="!disablePosters && movie.moviePosters">
        <div id="postersGallery" class="page-content slider-container">
          <feature-gallery-carousel
            *ngIf="movie.moviePosters"
            [images]="movie.moviePosters"
            [imageOrientation]="'portrait'"
          ></feature-gallery-carousel>
        </div>
      </div>
      <div
        class="slider-external-wrapper recomendations"
        *ngIf="recomendationSettings && movie?.movieRecommendations?.length > 0"
      >
        <div id="recomendationsGallery" class="page-content slider-container">
          <ush-movies-carousel [title]="'recomendations'" [movies]="movie.movieRecommendations"></ush-movies-carousel>
        </div>
      </div>

      <div *ngIf="showRightOwners && rightOwners">
        <div class="rightOwners page-content">
          <div class="subtitle" [attr.data-translate]="'movie.field.rightOwner'">
            {{ 'movie.field.rightOwner' | translate }}:
          </div>
          <div class="contractual-partners">
            <img
              *ngFor="let ro of rightOwners"
              [ngSrc]="ro.logoUrl"
              [alt]="ro.name"
              width="200"
              height="50"
              style="height: auto"
            />
          </div>
        </div>
      </div>

      @if (movie.newsPosts?.length) {
        @defer (on viewport) {
          <community-feature-news-carousel
            [news]="movie.newsPosts"
            newsSubtitle=""
            viewAllLink=""
          ></community-feature-news-carousel>
        } @placeholder {
          <div>This is news placeholder</div>
        }
      }
    </ng-container>
  </div>
</ng-container>

<!-- DETAIL CONTENT 2 - ALTERNATIVE LAYOUT -->
<ng-template #detailContent2 let-movie>
  <ng-container>
    <div class="movie-detail-content-2">
      <div id="showtimeStreamingWidget">
        <div class="top page-content">
          <div id="showtimeStreaming">
            <ush-showtime-streaming [movie]="movie"></ush-showtime-streaming>
          </div>
        </div>
      </div>

      <div id="moreInfoContent" class="movie-info-wrapper">
        <div class="movie-info-content page-content">
          <div class="col col-0">
            <div class="movie-pic">
              <img
                [ngSrc]="movie.portraitPhotoUrl || portraitPlaceholder"
                [alt]="movie.trTitle + ' poster image'"
                width="300"
                height="400"
                style="height: auto; width: 100%"
                [modal]="{ src: movie.portraitPhotoUrl, type: 'portrait', movie: movie, imgType: 'poster-img' }"
                addSkeleton
              />
            </div>
            <ng-container *ngIf="!shareInThumbnail">
              <ush-movie-tell-friends [movie]="movie"></ush-movie-tell-friends>
            </ng-container>
          </div>
          <div class="col col-1">
            <ush-movie-synopsis [movie]="movie"></ush-movie-synopsis>
            <ush-movie-reasons-to-watch *ngIf="movie.trReasonsToWatch" [movie]="movie"></ush-movie-reasons-to-watch>
          </div>
          <div class="col col-2">
            <ush-movie-credits *ngIf="movie.movieCrew" [movie]="movie"></ush-movie-credits>
            <ush-movie-more-information
              *ngIf="thereIsMoreInfo(movie)"
              [movie]="movie"
              [channel]="channel"
              [showPortrait]="false"
              class="main"
            ></ush-movie-more-information>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #noMovieDetailTemplate>
  <div class="no-movie-detail-container" *ngIf="movie">
    <img
      *ngIf="movie.tilePhotoUrl && !movieLandscapeImageBroken"
      (error)="onImgError('landscape')"
      [ngSrc]="movie.tilePhotoUrl || landscapePlaceholder"
      [alt]="movie.trTitle + ' placeholder'"
      fill="true"
      style="object-fit: cover"
      sizes="100vw"
      style="height: auto"
    />
    <img
      *ngIf="movieLandscapeImageBroken"
      [ngSrc]="landscapePlaceholder"
      [alt]="movie.trTitle + ' placeholder'"
      fill="true"
      style="object-fit: cover"
      sizes="100vw"
    />

    <!-- <img *ngIf="movie.tilePhotoUrl" [src]="movie.tilePhotoUrl | img: { width: 500 }" alt="no movie default placeholder" class="no-movie-detail-img" /> -->
    <div class="no-movie-detail-text">{{ 'movie.no-movie-detail-landing-page' | translate }}</div>
  </div>
</ng-template>
